<template>
  <div class="flex flex-col gap-100">
    <component
      :is="IMPLEMENTATIONS[account.type]"
      v-bind="{ accounts, storedAccounts }"
      v-for="account in accounts"
      :key="account.id"
      @manual-transfer-requested="emit('manual-transfer-requested')"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  type InitialPayOutAccount,
  PayOutAccountType,
} from '#api/shared/@types/generated/backend/graphql-schema-types'
import { PayoutNewMethodAeropay, PayoutNewMethodBank } from '#components'

import type { PayoutStoredAccounts } from './PayoutStoredComponentMapper'

type PayoutNewMethodSelectorEmits = {
  (e: 'manual-transfer-requested'): void
}
type PayoutNewMethodSelectorProps = {
  accounts: InitialPayOutAccount[]
  storedAccounts?: PayoutStoredAccounts
}

const IMPLEMENTATIONS = {
  [PayOutAccountType.Aeropay]: PayoutNewMethodAeropay,
  [PayOutAccountType.Bank]: PayoutNewMethodBank,
  [PayOutAccountType.PayPal]: null,
} as const

defineProps<PayoutNewMethodSelectorProps>()
const emit = defineEmits<PayoutNewMethodSelectorEmits>()
</script>
